import {
    ADDORUPDATESUBMODULEMASTERFORADMIN_SUCCESS,
    ADDORUPDATESUBMODULEMASTERFORADMIN_FAILED,
    RESET_ADDORUPDATESUBMODULEMASTERFORADMIN,
    LOADING_ADDORUPDATESUBMODULEMASTERFORADMIN,
    NETWORK_ERROR_ADDORUPDATESUBMODULEMASTERFORADMIN,
} from "../types/index";
import { adminServices } from "../../config/axios";


const resetAddOrUpdateSubModuleMasterForAdminList = () => {
    return { type: RESET_ADDORUPDATESUBMODULEMASTERFORADMIN };
};

const AddOrUpdateSubModulesMasterAdminLists = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_ADDORUPDATESUBMODULEMASTERFORADMIN });
    await adminServices
        .post("addOrUpdateSubModulemasterforadmin", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                
                case "success":
                    dispatch(addOrUpdateSubModuleMasterAdminListsuccess(res.data));
                    break;
                default:
                    dispatch(addOrUpdateSubModuleMasterAdminListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_ADDORUPDATESUBMODULEMASTERFORADMIN,
                payload: err
            });
        });
};


function addOrUpdateSubModuleMasterAdminListsuccess(data) {
    return {
        type: ADDORUPDATESUBMODULEMASTERFORADMIN_SUCCESS,
        payload: data
    };
}
function addOrUpdateSubModuleMasterAdminListFailed(data) {
    return {
        type: ADDORUPDATESUBMODULEMASTERFORADMIN_FAILED,
        payload: data
    };
}

export { AddOrUpdateSubModulesMasterAdminLists, resetAddOrUpdateSubModuleMasterForAdminList }